import Axios from '../axios-instance';

const ActivityLogAPI = {
  get: body => {
    return Axios.post(`/ActivityLogs/Get`, body).then(({ data }) => data);
  },
  exportToExcel: body => {
    return Axios.post('/ActivityLogs/exportToExcel', body, { responseType: 'arraybuffer' }).then(({ data }) => data);
  },

  registerLogout: body => {
    //return Axios.post(`ActivityLogs/registerLogout/${ userFullName }`).then(({ data }) => data);
    return Axios.post('ActivityLogs/registerLogout', body ).then(({ data }) => data);
  },

};


export default ActivityLogAPI;